import QueryManager from "../../../global/utils/QueryManager";
import {getLocalStorageKey} from "../../../settings";
import {ContractsFiltersTypes} from "./Contracts.filters.types";

const curLocalStorageKey = getLocalStorageKey("contracts_filters");

let contractFiltersSerializableDates = [
    ContractsFiltersTypes.CompletionDate,
    ContractsFiltersTypes.SignedDate,
    ContractsFiltersTypes.StartDate
]

let contractFiltersSerializableJoins = [
    ContractsFiltersTypes.Keywords,
    ContractsFiltersTypes.Naics,
    ContractsFiltersTypes.PopState,
    ContractsFiltersTypes.PscCode,
]

class ContractsFilterManagerClass extends QueryManager {}

const ContractsFilterManager = new ContractsFilterManagerClass({
    serializable: {dates: contractFiltersSerializableDates, joins: contractFiltersSerializableJoins},
    localStorageKey: curLocalStorageKey
});

export default ContractsFilterManager;